import React, { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomTextField from "../../infrastructure/components/CustomTextField";

const CustomPasswordField = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  return (
    <CustomTextField
      sx={{
        width: props?.width ?? "100%",
      }}
      id={props.name}
      label={props.label}
      name={props.name}
      variant="outlined"
      value={props.formik?.values[props.name]}
      onChange={props.formik.handleChange}
      error={
        props.formik.touched[props.name] &&
        Boolean(props.formik.errors[props.name])
      }
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      helperText={
        props.formik.touched[props.name] && props.formik.errors[props.name]
      }
      FormHelperTextProps={{
        sx: {
          margin: "0px",
        },
      }}
    />
  );
};

export default CustomPasswordField;
